import React from 'react';
import { Badge, BlockStack, Card, InlineStack, Text } from '@shopify/polaris';
import { BUNDLE_APPS, IBundleApp } from './config';
import AppChip from './AppChip';
import PlanGrid from './PlanGrid';

interface ITrakowCardProps {
  selectedPlanId: string;
  onChange: (planId: string) => void;
  app?: IBundleApp;
  isLoading?: boolean;
}

const TrakowCard = ({ selectedPlanId, onChange, app = BUNDLE_APPS[0], isLoading }: ITrakowCardProps) => (
  <Card>
    <BlockStack gap="300">
      <InlineStack gap="200" blockAlign="center">
        <AppChip color={app.color} letter={app.letter} label={app.name} logo={app.logo} size={32} />
        <BlockStack gap="025">
          <InlineStack gap="150" blockAlign="center">
            <Text variant="headingLg" as="h3">
              {app.name}
            </Text>
            <Badge tone="info" progress="complete">
              Installed
            </Badge>
          </InlineStack>
          <Text variant="bodySm" tone="subdued" as="span">
            {app.desc}
          </Text>
        </BlockStack>
      </InlineStack>
      <PlanGrid app={app} selectedPlanId={selectedPlanId} onChange={onChange} isLoading={isLoading} />
    </BlockStack>
  </Card>
);

export default TrakowCard;
